enum HttpCodeConstants {
  FORBIDDEN = 403,
  USER_SESSION_DOES_NOT_EXIST = 999,
  WEB_USER_INACTIVE = 994,
  NO_ROLE_ASSIGNED = 997,
  INVALID_TOKEN = 998
}

export default HttpCodeConstants;
